import { render, staticRenderFns } from "./TermsModal.vue?vue&type=template&id=10c2e7e2&scoped=true&"
import script from "./TermsModal.vue?vue&type=script&lang=js&"
export * from "./TermsModal.vue?vue&type=script&lang=js&"
import style0 from "./TermsModal.vue?vue&type=style&index=0&id=10c2e7e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c2e7e2",
  null
  
)

component.options.__file = "TermsModal.vue"
export default component.exports